<template>
  <div
    v-show="crumbsStore.getCrumbs['parent']"
    class="mb-5 flex flex-col rounded-xl font-roboto shadow-drop-0"
  >
    <div :class="{ expanded: isExpanded }" class="flex">
      <div class="ml-7 mt-4 self-start">
        <div
          class="grid size-6 min-w-[24px] place-content-center rounded"
          :class="[
            isExpanded && hasCrumbsCount
              ? 'rotate-180 bg-[#F9F0F1] text-ruby-red-100'
              : 'bg-ruby-red-100 text-white-100',
            { 'cursor-pointer': hasCrumbsCount },
          ]"
          @click="toggleExpanded"
        >
          <SvgIcon name="chevron-down" class="size-4"></SvgIcon>
        </div>
      </div>
      <div class="content m-3 overflow-hidden">
        <TransitionGroup name="list">
          <div key="multiply" class="overflow-hidden">
            <TransitionGroup name="fade">
              <template v-for="(crumb, level) in crumbs" :key="crumb">
                <div
                  v-if="crumbsStore.getCrumbs[crumb]"
                  class="mb-1 flex items-center font-roboto text-[12px] font-medium leading-[24px] text-[#949494] last:pointer-events-none last:font-semibold last:text-[#1d1d1d] empty:mb-0 md:text-[14px] last:md:text-[26px] last:md:leading-[38px]"
                  :class="{
                    'pointer-events-none':
                      crumbsStore.getCrumbs[crumb]?.slug === route.fullPath ||
                      !crumbsStore.getCrumbs['paragraph'],
                  }"
                  :style="`padding-left: ${(level + 1) * 8}px`"
                >
                  <NuxtLink
                    :to="crumbsStore.getCrumbs[crumb]?.slug"
                    class="flex items-center"
                  >
                    <div class="grid h-6 place-content-center">
                      <SvgIcon
                        name="level-arrow"
                        class="mr-1.5 size-4 min-w-[16px]"
                      />
                    </div>
                    <div class="text-clamp-1 md:text-clamp-3">
                      {{ crumbsStore.getCrumbs[crumb]?.title }}
                    </div>
                  </NuxtLink>
                </div>
              </template>
            </TransitionGroup>
          </div>
          <div
            v-if="!isExpanded"
            key="single"
            class="flex items-center font-semibold text-[#1d1d1d] md:text-[26px] md:leading-[38px]"
          >
            <div class="grid h-6 place-content-center">
              <SvgIcon name="level-arrow" class="mr-1.5 size-4 min-w-[16px]" />
            </div>
            <div class="line-clamp-1 md:line-clamp-3">
              {{ lastCrumbs?.title }}
            </div>
          </div>
        </TransitionGroup>
      </div>
    </div>
    <div
      v-if="lastCrumbs?.preamble"
      class="px-7 pb-4 pt-1 text-[14px] leading-6 empty:p-0"
    >
      <TeacherPreambula
        v-bind="{
          text: lastCrumbs?.preamble ? lastCrumbs.preamble : undefined,
          charCount: Object.keys(charCount).length ? charCount : undefined,
        }"
      />
    </div>
  </div>
</template>

<script setup>
defineProps({
  charCount: {
    type: Object,
    default: () => ({}),
  },
});
const crumbs = ['parent', 'chapter', 'paragraph', 'slug'];
const route = useRoute();
const crumbsStore = useBreadcrumbsStore();
const isExpanded = ref(true);

const lastCrumbs = computed(() => {
  const storeCrumbs = crumbsStore.getCrumbs;
  for (const [index, crumb] of crumbs.entries()) {
    if (!storeCrumbs[crumbs[index + 1]]) {
      return storeCrumbs[crumb];
    }
  }
});

const hasCrumbsCount = computed(() => {
  return !!crumbsStore.getCrumbs['chapter'];
});

const toggleExpanded = () => {
  if (!hasCrumbsCount.value) return;
  isExpanded.value = !isExpanded.value;
};
</script>

<style lang="scss">
.content {
  @apply grid transition-all duration-500 grid-rows-[0fr];
  .expanded & {
    @apply grid-rows-[1fr];
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from {
  opacity: 0;
  transform: translateX(30px);
}
.list-leave-to {
  opacity: 0;
  height: 0;
  transform: translate(30px, -15px);
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-in;
}
.fade-enter-from {
  opacity: 0;
  transform: translateY(10px);
}
.fade-leave-to {
  opacity: 0;
  transform: translateX(15px);
}
</style>
